/*
|--------------------------------------------------------------------------
| Current Page
|--------------------------------------------------------------------------
*/
/**
 * Functionality for the current page
 * @namespace
 */
__gh__webApp.currentPage = {
	"is101Things": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "section" && pageData.profileType == "101Things") ? true : false;
	},
	"isArticle": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "article") ? true : false;
	},
	"isHome": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "frontpage") ? true : false;
	},
	"isImageDriven": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "section" && pageData.profileType == "imageDriven") ? true : false;
	},
	"isPhotos": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "section" && pageData.profileType == "multimediaPhoto") ? true : false;
	},
	"isSearch": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "search") ? true : false;
	},
	"isSection": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "section") ? true : false;
	},
	"isSectionStandard": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "section" && pageData.profileType == "standard") ? true : false;
	},
	"isSectionBasic": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "section" && pageData.profileType == "basic") ? true : false;
	},
	"isSectionEnhanced": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "section" && pageData.profileType == "enhanced") ? true : false;
	},
	"isVideo": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "section" && pageData.profileType == "multimediaVideo") ? true : false;
	},
	"isWrapper": function(){
		var pageData = __gh__coreData.pageData;
		return (pageData.pageType == "wrapper");
	}
};
